import * as React from 'react';
import { Styles } from '@vivli/shared/theme';

export function CopyrightComponent() {
    return <div style={{ ...Styles.VIVLI_COPYRIGHT }}>&copy; Copyright 2017 - {new Date().getFullYear()} Vivli</div>;
}
